<template>
	<div id="app">
		<NavTop v-show="lang == 'zh' || lang == 'en'"/>
		<YoungNavTop v-show="lang == 'young' && showTop"/>
		<TopMainImage v-show="lang == 'zh' || lang == 'en'"/>
		<second-nav v-show="lang == 'zh' || lang == 'en'"/>
		<router-view v-if="isRouterAlive"/>
		<Footer v-show="lang == 'zh' || lang == 'en'"/>
	</div>
</template>

<script>
import NavTop from '@/components/NavTop'
import Footer from '@/components/Footer'
import SecondNav from '@/components/SecondNav'
import TopMainImage from '@/components/TopMainImage'
import YoungNavTop from '@/components/YoungNavTop'

export default {
	name: 'App',
	components: {
		NavTop, Footer, SecondNav, TopMainImage, YoungNavTop
	},
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			isRouterAlive: true
		}
	},
	computed: {
		lang() {
			console.log(this.$store)
			return this.$store.state.lang
		},
		showTop() {
			return this.$store.state.showTop
		}
	},
	created () {
	    //在页面加载时读取sessionStorage里的状态信息
	    if (sessionStorage.getItem("store") ) {
			this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))));
			// sessionStorage.removeItem('store');
	    }

	    //在页面刷新时将vuex里的信息保存到sessionStorage里
	    window.addEventListener("beforeunload",()=>{
			sessionStorage.setItem("store",JSON.stringify(this.$store.state))
	    })
		this.$Message.config({
		    top: 400,
		    duration: 3
		});
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function(){
				this.isRouterAlive = true;
			})
		},
	}
}
</script>

<style lang="less">
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100%;
		min-width: 1500px;
	}

	.inner-content {
		width: 1142px;
		margin: 30px auto 80px;
		font-size: 12px;
		color: #333333;
		text-align: left;
		padding: 0 20px;
		border-left: 1px solid #cccccc;
		border-right: 1px solid #cccccc;
		border-bottom: 1px solid #cccccc;
		border-radius: 5px;
		.back {
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			cursor: pointer;
			margin: 40px auto 20px;
		}
	}
	.demo-spin-icon-load{
		animation: ani-demo-spin 1s linear infinite;
	}
	.column-flex {
		display: flex;
		flex-direction: column;
	}
	.ivu-modal-header {
		padding: 0;
	}
	.ivu-modal-body {
		padding: 0;
	}
	.wh_container{
	    height:100%;
	    max-height:100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		font-size: 12px!important;
	}
	.wh_content_all{
	    background-color: #2460A7!important;
	    height:100%;
	}
	.wh_top_changge {
		background-color: #55CCEE!important;
	}
	.wh_top_changge {
		height: 12%;
		li {
			height: 20px!important;
			font-size: 12px!important;
		}
		.wh_jiantou1 {
			width: 9px!important;
			height: 9px!important;
		}
		.wh_jiantou2 {
			width: 9px!important;
			height: 9px!important;
		}
	}
	.wh_content {
		height: 12%!important;
		.wh_content_item {
			height: 100%!important;
			font-size: 10px!important;
			margin-top: 3px;
			color: #55CCEE!important;
			.wh_item_date {
				padding: 0!important;
				border-radius: 50%!important;
				width: 16px!important;
			}
			.wh_isToday {
				background: #55CCEE!important;
				color: #01009A!important;
			}
			.wh_chose_day {
				background: #2460A7!important;
				color: #55CCEE!important;
			}
			.wh_item_date:hover{
			    background: #2460A7!important;
			    color: #55CCEE!important;
			}

			.wh_top_tag {
				height: 16px!important;
				width: 16px!important;
			}
			.wh_item_date {
				height: 16px!important;
			}
		}
	}
	.ivu-upload-list {
		display: none;
	}
	Scroll {
		html::-webkit-scrollbar, body::-webkit-scrollbar{
			width:0px;
			height:0px;
		}
		
	}


</style>



// WEBPACK FOOTER //
// src/App.vue